import { makeOptions } from "./upliftConstant";

export const KYC_MARKER = "KYC" as const;

export const PEPGroupMarkers = {
  REF: "PEPR"
} as const;

export const SanctionsGroupMarkers = {
  REF: "SANR"
} as const;

export const RiskRatingGroupMarkers = {
  REF: "HRAF"
} as const;

export const IDVGroupMarkers = {
  REF: "IDVR",
  PASS: "IDVP"
} as const;

export const NoneGroupMarkers = {
  ADV: "ADV",
  RCA: "RCA",
  SOW: "SOW",
  SOF: "SOF",
  KYC: "KYC"
} as const;

export const MarkerGroups = {
  AMLS: "AMLS",
  PEPS: "PEPS",
  SANS: "SANS",
  RSKS: "RSKS",
  IDVS: "IDVS",
  NONE: "NONE" // virtual group for those markers with no group code
} as const;

export const { options: markerGroupOptions, namings: MarkerGroupNamings } = makeOptions([
  ["NONE", "None"],
  ["PEPS", "PEP Status"],
  ["SANS", "Sanctions Status"],
  ["RSKS", "Risk Rating"],
  ["IDVS", "ID&V Status"],
] as const);

export const REFER_MARKERS: string[] = [PEPGroupMarkers.REF, SanctionsGroupMarkers.REF, RiskRatingGroupMarkers.REF, IDVGroupMarkers.REF];
